// extracted by mini-css-extract-plugin
export default {"loadingContainer":"AddSubscriptionsTab_loadingContainer__5Bvy5","scrollableContainer":"AddSubscriptionsTab_scrollableContainer__fd+uS"};